import { useState } from 'react';
// import { useAuthStore } from '../../stores/auth-store';
import SettingsTabs from '../../components/filters/SettingsTabs';
import ProfileScreen from './components/ProfileScreen';
import UsersScreen from './components/UsersScreen';
import RolesScreen from './components/RolesScreen';
import MKTConfigurationScreen from './components/MKTConfigurationScreen';
import LabelScreen from './components/LabelScreen';
import FulfillmentCardScreen from './components/FulfillmentCardScreen';

export default function SettingsPage() {
  // const { token } = useAuthStore();
  const [selectedTab, setSelectedTab] = useState('profile');
  const [selectedSubTab, setSelectedSubTab] = useState('user_list');
  

  // const [isDisabling, setIsDisabling] = useState(false);
  const [error] = useState<string | null>(null);
  const [success] = useState<string | null>(null);



  const handleTabSelect = (tab: string) => {
    setSelectedTab(tab);
    // Reset sub-tab when switching to Users tab
    if (tab === 'users') {
      setSelectedSubTab('user_list');
    }
  };

  const handleSubTabSelect = (subTab: string) => {
    setSelectedSubTab(subTab);
  };

  const renderSelectedScreen = () => {
    switch (selectedTab) {
      case 'profile':
        return <ProfileScreen />;
      case 'users':
        // Handle sub-tabs for Users
        switch (selectedSubTab) {
          case 'user_list':
            return <UsersScreen />;
                     case 'roles':
             return <RolesScreen />;
          default:
            return <UsersScreen />;
        }
      case 'mkt_configuration':
        return <MKTConfigurationScreen />;
      case 'label':
        return <LabelScreen />;
      case 'fulfillment_card':
        return <FulfillmentCardScreen />;
      default:
        return <ProfileScreen />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Error Message */}
      {error && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">{error}</p>
        </div>
      )}

      {/* Success Message */}
      {success && (
        <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm text-green-600">{success}</p>
        </div>
      )}

      {/* Settings Tabs */}
      <SettingsTabs 
        selected={selectedTab} 
        onSelect={handleTabSelect}
        onSubStatusSelect={handleSubTabSelect}
        selectedSubStatus={selectedSubTab}
      />

      {/* Selected Screen */}
      {renderSelectedScreen()}
    </div>
  );
}
